// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  background-color: #353535;
  opacity: 0.4;
  grid-column-start: 1;
  grid-column-end: 11;
  grid-row-start: 1;
  grid-row-end: 1;
}
.drawer {
  position: relative;
  background-color: #ffffff;
  box-shadow: -1px 0 9px 0 rgba(0, 0, 0, 0.1);
  grid-row-start: 1;
  grid-row-end: 1;
}
.drawerCatchError {
  composes: drawer;
  grid-column-start: 1;
  grid-column-end: 11;
  background-color: #D86E6B;
}
.drawerThird {
  composes: drawer;
  grid-column-start: 8;
  grid-column-end: 11;
}
@media (max-width: 768px) {
  .drawerThird {
    grid-column-start: 1;
    grid-column-end: 11;
  }
}
.drawerHalf {
  composes: drawer;
  grid-column-start: 6;
  grid-column-end: 11;
}
@media (max-width: 768px) {
  .drawerHalf {
    grid-column-start: 1;
    grid-column-end: 11;
  }
}
.drawerTwoThirds {
  composes: drawer;
  grid-column-start: 3;
  grid-column-end: 11;
}
@media (max-width: 768px) {
  .drawerTwoThirds {
    grid-column-start: 1;
    grid-column-end: 11;
  }
}
.drawerFull {
  composes: drawer;
  grid-column-start: 1;
  grid-column-end: 11;
}
.drawerMiddle {
  composes: drawer;
  grid-column-start: 2;
  grid-column-end: 10;
}
@media (max-width: 768px) {
  .drawerMiddle {
    grid-column-start: 1;
    grid-column-end: 11;
  }
}
.drawerPopup {
  composes: drawer;
  grid-column-start: 3;
  grid-column-end: 9;
  margin-top: 0%;
  height: 100%;
}
@media (min-height: 500px) {
  .drawerPopup {
    margin-top: 12%;
    height: 300px;
  }
}
@media (min-height: 600px) {
  .drawerPopup {
    margin-top: 12%;
    height: 400px;
  }
}
@media (min-height: 700px) {
  .drawerPopup {
    margin-top: 12%;
    height: 500px;
  }
}
@media (min-height: 800px) {
  .drawerPopup {
    margin-top: 12%;
    height: 600px;
  }
}
@media (min-height: 900px) {
  .drawerPopup {
    margin-top: 12%;
    height: 700px;
  }
}
@media (min-width: 992px) {
  .drawerPopup {
    grid-column-start: 4;
    grid-column-end: 8;
  }
}
.drawerStatic {
  composes: drawer;
  grid-column-start: 1;
  grid-column-end: 11;
  background-color: transparent;
}
.drawerBackdrop {
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: transparent;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/Views/Drawer/DrawerContainer.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AADF;AAIA;EACE,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,iBAAA;EACA,eAAA;AAFF;AAKA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AAHF;AAMA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AAJF;AAKE;EAAA;IACE,oBAAA;IACA,mBAAA;EAFF;AACF;AAKA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AAHF;AAIE;EAAA;IACE,oBAAA;IACA,mBAAA;EADF;AACF;AAIA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AAFF;AAGE;EAAA;IACE,oBAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AADF;AAIA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AAFF;AAGE;EAAA;IACE,oBAAA;IACA,mBAAA;EAAF;AACF;AAGA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AADF;AAEE;EAAA;IACE,eAAA;IACA,aAAA;EACF;AACF;AAAE;EAAA;IACE,eAAA;IACA,aAAA;EAGF;AACF;AAFE;EAAA;IACE,eAAA;IACA,aAAA;EAKF;AACF;AAJE;EAAA;IACE,eAAA;IACA,aAAA;EAOF;AACF;AANE;EAAA;IACE,eAAA;IACA,aAAA;EASF;AACF;AARE;EAAA;IACE,oBAAA;IACA,kBAAA;EAWF;AACF;AARA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,6BAAA;AAUF;AALA;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,sCAAA;EACA,gBAAA;AAOF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n// overlay\n.overlay {\n  background-color: @background-dark1;\n  opacity: 0.4;\n  grid-column-start: 1;\n  grid-column-end: 11;\n  grid-row-start: 1;\n  grid-row-end: 1;\n}\n\n.drawer {\n  position: relative;\n  background-color: @background-white1;\n  box-shadow: -1px 0 9px 0 rgba(0,0,0,0.1);\n  grid-row-start: 1;\n  grid-row-end: 1;\n}\n\n.drawerCatchError {\n  composes: drawer;\n  grid-column-start: 1;\n  grid-column-end: 11;\n  background-color: @highlight-color;\n}\n\n.drawerThird {\n  composes: drawer;\n  grid-column-start: 8;\n  grid-column-end: 11;\n  @media (max-width: 768px) {\n    grid-column-start: 1;\n    grid-column-end: 11;\n  }\n}\n\n.drawerHalf {\n  composes: drawer;\n  grid-column-start: 6;\n  grid-column-end: 11;\n  @media (max-width: 768px) {\n    grid-column-start: 1;\n    grid-column-end: 11;\n  }\n}\n\n.drawerTwoThirds {\n  composes: drawer;\n  grid-column-start: 3;\n  grid-column-end: 11;\n  @media (max-width: 768px) {\n    grid-column-start: 1;\n    grid-column-end: 11;\n  }\n}\n\n.drawerFull {\n  composes: drawer;\n  grid-column-start: 1;\n  grid-column-end: 11;\n}\n\n.drawerMiddle {\n  composes: drawer;\n  grid-column-start: 2;\n  grid-column-end: 10;\n  @media (max-width: 768px) {\n    grid-column-start: 1;\n    grid-column-end: 11;\n  }\n}\n\n.drawerPopup {\n  composes: drawer;\n  grid-column-start: 3;\n  grid-column-end: 9;\n  margin-top: 0%;\n  height: 100%;\n  @media (min-height: 500px) {\n    margin-top: 12%;\n    height: 300px;\n  }\n  @media (min-height: 600px) {\n    margin-top: 12%;\n    height: 400px;\n  }\n  @media (min-height: 700px) {\n    margin-top: 12%;\n    height: 500px;\n  }\n  @media (min-height: 800px) {\n    margin-top: 12%;\n    height: 600px;\n  }\n  @media (min-height: 900px) {\n    margin-top: 12%;\n    height: 700px;\n  }\n  @media (min-width: 992px) {\n    grid-column-start: 4;\n    grid-column-end: 8;\n  }\n}\n\n.drawerStatic {\n  composes: drawer;\n  grid-column-start: 1;\n  grid-column-end: 11;\n  background-color: transparent;\n}\n\n\n\n.drawerBackdrop {\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  right: 0px;\n  background-color: transparent;\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
